<template>
  <div class="wrapper">
    <form id="search">
      <div id="filter-results" class="bg-ghost-gray pam">
        <div class="h5">Filter results</div>
        <div class="grid-x grid-margin-x">
          <div class="cell medium-18 small-11">
            <input
              type="text"
              name="query"
              v-model="searchQuery"
              placeholder="Type to filter the grid data..."
              class="inputS"
            />
          </div>
          <div class="cell medium-6 small-24">
            <a class="button content-type-featured full" @click.prevent="reset()">Clear filter</a>
          </div>
          <!--<div class="cell medium-4 small-11">
            Show request(s)
            <select v-model="rowsPerPage">
              <option v-for="pageSize in pageSizeMenu" :value="pageSize">{{pageSize}}</option>
            </select>
          </div>-->
        </div>
      </div>
    </form>
    <div id="grid-template">
      <div>
        <br />
        <span>
          Found
          <b>{{filteredData.length}}</b> Request(s)...
        </span>
      </div>
      <div class="table-header-wrapper">
        <table :class="classTable">
          <thead>
            <th
              v-for="key in columns"
              @click.prevent="sortBy(key)"
              :class="{ active: sortKey == key }"
            >
              {{ key | capitalize }}
              <span
                class="arrow"
                :class="sortOrders[key] > 0 ? 'asc' : 'dsc'"
              ></span>
            </th>
          </thead>
          <tbody>
            <tr v-for="entry in dataPerPage">
              <td v-for="key in columns">
                <!--<span v-html="entry[key]"></span>-->
                <span v-if="entry[key]=='View/Edit'">
                  <a
                    class="button content-type-featured full"
                    @click.prevent="openModal(entry.Id)"
                  >{{entry[key]}}</a>
                </span>
                <span v-else-if="entry[key]=='View'">
                  <a
                    class="button content-type-featured full"
                    @click.prevent="openModal(entry.Id)"
                  >{{entry[key]}}</a>
                </span>
                <span v-else>{{entry[key]}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div id="page-navigation paginationAlign">
      <ul class="paginate-links documents">
        <li class="left-arrow" v-if="startPage > 1">
          <a @click.prevent="movePages(-1)">Previous</a>
        </li>
        <!--<li class="number active">
          <p>{{startPage}} out of {{totalPages}}</p>
        </li>-->
        <li
          v-for="pageNumber in totalPages"
          v-if="Math.abs(pageNumber - currentPage) < 3 || pageNumber == totalPages || pageNumber == 1"
        >
          <a
            v-bind:key="pageNumber"
            @click.prevent="setPage(pageNumber)"
            :class="{current: currentPage === pageNumber, last: (pageNumber == totalPages && Math.abs(pageNumber - currentPage) > 3), first:(pageNumber == 1 && Math.abs(pageNumber - currentPage) > 3)}"
          >{{ pageNumber }}</a>
        </li>
        <li class="right-arrow" v-if="startPage != totalPages">
          <a @click.prevent="movePages(1)">Next</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Grid",
  props: {
    data: Array,
    columns: Array,
    classTable: { type: String, default: "" },
    rowsPerPage: { type: Number, default: 10 },
    pageSizeMenu: { type: Number, default: 10 }
  },
  data() {
    return {
      searchQuery: "",
      sortKey: "",
      sortOrders: {},
      startRow: 0,
      currentPage: 1
    };
  },
  computed: {
    filteredData() {
      let sortKey = this.sortKey;
      let filterKey = this.searchQuery && this.searchQuery.toLowerCase();
      let order = this.sortOrders[sortKey] || 1;
      let data = this.data;

      if (filterKey) {
        data = data.filter(function(row) {
          return Object.keys(row).some(function(key) {
            return (
              String(row[key])
                .toLowerCase()
                .indexOf(filterKey) > -1
            );
          });
        });
      }
      if (sortKey) {
        data = data.slice().sort(function(a, b) {
          a = a[sortKey];
          b = b[sortKey];
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }
      return data;
    },
    dataPerPage() {
      return this.filteredData.filter(
        (item, index) =>
          index >= this.startRow && index < this.startRow + this.rowsPerPage
      );
    },
    startPage() {
      return this.startRow / this.rowsPerPage + 1;
    },
    totalPages: function() {
      return Math.ceil(this.filteredData.length / this.rowsPerPage);
    }
  },
  filters: {
    capitalize: function(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  paginate() {
    if (
      !this.filteredData ||
      this.filteredData.length != this.filteredData.length
    ) {
      return;
    }

    if (this.currentPage >= this.totalPages) {
      this.currentPage = this.totalPages;
    }
    var index = this.currentPage * this.rowsPerPage - this.rowsPerPage;
    return this.filteredData.slice(index, index + this.rowsPerPage);
  },
  methods: {
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
    movePages(amount) {
      let newStartRow = this.startRow + amount * this.rowsPerPage;
      if (newStartRow >= 0 && newStartRow < this.filteredData.length) {
        this.startRow = newStartRow;
      }
    },
    setPage(pageNumber) {
      this.currentPage = pageNumber;
    },
    reset: function() {
      this.searchQuery = "";
    },
    openModal(Id) {
      this.$emit("openModal", Id);
    }
  },
  created() {
    let sortOrders = {};
    this.columns.forEach(function(key) {
      sortOrders[key] = 1;
    });
    this.sortOrders = sortOrders;
  }
};
</script>

<style scoped>
th.active {
  color: #000000;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #000000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000000;
}
.inputS {
  background-color: #ffffff;
}
a.first::after {
  content: "...";
}

a.last::before {
  content: "...";
}
.paginationAlign {
  display: flex;
  align-items: center;
}

@media screen and (min-width: 65.625em) {
  .archive-results .title {
    width: 500px;
  }

  .archive-results .date {
    width: 150px;
  }
}

.table-sort {
  position: relative;
  cursor: pointer;
  color: white;
  padding-right: 2rem;
}

.table-sort span::after {
  position: absolute;
  display: inline;
  content: "";
  margin: auto 10px auto;
  width: 0;
  height: 0;
  border: inset 5px;
  border-color: white transparent transparent;
  border-top-style: solid;
  border-bottom-width: 0;
  float: none;
  top: 0;
  bottom: 0;
  height: 10px;
}

.table-sort.asc span::after {
  border-color: transparent transparent white;
  border-bottom-style: solid;
  border-bottom-width: 5px;
}

table.theme-light .table-sort span::after {
  border-color: #444 transparent transparent;
}

table.theme-light .table-sort.asc span::after {
  border-color: transparent transparent #444;
}

table.theme-light thead {
  border-bottom: 5px solid #444;
  background: white;
}

table.theme-light th {
  background: white;
  text-transform: uppercase;
  color: #444;
}

table.theme-light tbody {
  border: none;
  background-color: white;
}

table.theme-light tbody tr:nth-child(even) {
  background-color: white;
}

table.theme-light td {
  border-top: none;
  border-left: none;
  border-right: none;
}

@media screen and (min-width: 46.875em) {
  table.theme-light td {
    padding: 1.5rem 0.5rem;
    border-bottom: 1px solid #444;
  }
}

@media screen and (max-width: 46.8125em) {
  table.theme-light td {
    border-bottom: none;
  }

  table.theme-light tr {
    border-bottom: 1px solid #444;
  }
}

table.theme-light a:link,
table.theme-light a:visited {
  color: #444;
}

table.theme-light .vue-clickable-row:hover,
table.theme-light .clickable-row:hover {
  cursor: pointer;
  opacity: 1;
  background: #f0f0f0;
}

@media screen and (max-width: 46.8125em) {
  table.stack thead th {
    display: block;
  }

  table.stack tfoot {
    display: none;
  }

  table.stack tr,
  table.stack th,
  table.stack td {
    display: block;
  }

  table.stack td {
    border-top: 0;
  }
}

ul.paginate-links,
.pagination,
.pagination-wrapper {
  display: inline-block;
  margin: 0;
  padding: 0;
}

ul.paginate-links li,
.pagination li,
.pagination-wrapper li {
  display: inline-block;
  border-right: 2px solid white;
  margin-bottom: 1rem;
}

ul.paginate-links li.disabled,
.pagination li.disabled,
.pagination-wrapper li.disabled {
  display: none;
}

ul.paginate-links a,
.pagination a,
.pagination-wrapper a {
  display: block;
  padding: 0.5rem;
  background: #0f4d90;
  color: white;
}

ul.paginate-links a,
.pagination a,
.pagination-wrapper a {
  color: white;
}

ul.paginate-links li.active a,
.pagination li.active a,
.pagination-wrapper li.active a {
  background: white;
  color: #444;
}

section ul.pagination-wrapper,
section ul.pagination-wrapper ul {
  overflow: initial;
}
</style>